const tabsName = [
	{
		"imageSrc": "../assets/diagram.svg",
		"description": "Bad affiliate traffic"
	}, {
		"imageSrc": "../assets/money.svg",
		"description": "Chargebacks various fraud cases"
	}, {
		"imageSrc": "../assets/man.svg",
		"description": "Account takeovers, scams, bot attacks"
	}
];

const swiperIndustries = new Swiper('.industries-slider__container', {
	loop: true,
	pagination: {
		el: '.industries-slider-pagination',
		clickable: true,
		renderBullet: function (index, className) {
			return '<div class="' + className + '"><img class="industries-slider__pagination-icon" src="' + tabsName[index].imageSrc + '" />' + (tabsName[index].description) + '</div>';
		},
	},
});
